module.exports = __webpack_public_path__ + "static/img/Export-active.a15fe9fd.svg";